// Types d'alertes pour les composants Tasks
export const success = 'success';
export const error = 'error';
export const erreur = 'error'; // Alias français
export const warning = 'warning';
export const info = 'info';
export const primary = 'primary';
export const secondary = 'secondary';
export const danger = 'danger';
